import { ResultOf } from 'gql.tada';
import { ApprovalStatus, TestResult } from '../../../../types/backflowTest';
import { gql } from '../../gql';

export const GET_TEST_REPORT_IDS = gql(`
  query GetTestReportIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    backflowTests(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["jobId"]
    ) {
      jobId
    }
  }
`);

export const GET_TEST_REPORTS = gql(`
  query GetTestReports(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    backflowTests(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      jobId
      waterSupplierStatus
      dateTested
      initialResult
      finalResult
      testingCompanyName
      testingCompanySubmitted
      testerName
      backflowAssemblyEdited
      properlyInstalled
      testable
      job(required: true) {
        address(required: true) {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        attachments {
          id
        }
      }
      backflowAssembly {
        model {
          name
          backflowAssemblyMake {
            name
          }
        }
        serialNumber
        size
        type
        location
        waterService {
          siteNumber
          pin
          serviceAddresses(where: { active: true }, required: true) {
            customer(where: { status: 1 }, required: true) {
              profile {
                name
              }
            }
          }
        }
      }
    }
  }
`);

export type TestReportItem = ResultOf<
  typeof GET_TEST_REPORTS
>['backflowTests'][number] & { testingCompanySubmitted: number };
